// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3jSdw","savePackageButton":"ClientWallet_savePackageButton__2jYGW"};